var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    { attrs: { value: "" } },
    [
      _c(
        "w-card",
        { attrs: { "max-width": "500" } },
        [
          _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("reset-numbering")))]),
          _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-input-number", {
                        attrs: {
                          decimals: 0,
                          min: 0,
                          label: _vm.$ct("next-number"),
                        },
                        model: {
                          value: _vm.value,
                          callback: function ($$v) {
                            _vm.value = $$v
                          },
                          expression: "value",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-card-actions",
            [
              _c(
                "w-button",
                {
                  staticClass: "cancel",
                  attrs: { icon: "ban" },
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
              ),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  attrs: { icon: "check" },
                  on: {
                    click: function ($event) {
                      return _vm.confirm()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }